var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYpnoss1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.26 15.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:12px;fill:#e97251;font-family:Comfortaa-Regular, Comfortaa;letter-spacing:-0.08em;}.cls-2{fill:#aa8977;}.cls-3{fill:#6aa09d;}.cls-4{fill:#3fb4be;letter-spacing:-0.08em;}.cls-5{fill:#addfd6;}.cls-6{font-size:3px;fill:#00acc1;font-family:Comfortaa-Bold, Comfortaa;font-weight:700;}.cls-7{letter-spacing:-0.03em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 10.69)"
  }, "y", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 5.62,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 13.14,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 20.3,
    y: 0
  }, "os"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 32.98,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("text", {
    className: "cls-6",
    transform: "translate(19.43 14.4)"
  }, "U", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 2.54,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.49,
    y: 0
  }, "wind with "))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYpnoss1);
export default __webpack_public_path__ + "static/media/ypnoss_1.7c1bc7be233de85a311ebecbffaadd4b.svg";
export { ForwardRef as ReactComponent };